import React, { FunctionComponent } from 'react'

import { Outlet } from 'react-router-dom'

import Illustration from '@/atoms/icons/approachable.svg'
import { Flex } from '@/atoms/layout'
import { NotMobile } from '@/helpers/media-queries'
import { Space } from '@/styles'

import PublicHeader from './public-header'
import { AppWrapper, ContentWrapper } from './public-layout-styles'

const PublicLayout: FunctionComponent = () => (
  <AppWrapper>
    <ContentWrapper>
      <PublicHeader />
      <Flex flex={1} mb={Space.S64}>
        <Flex width={[1, 3 / 5, 3 / 5]} pr={[0, Space.S40, Space.S40]} alignItems="center">
          <Outlet />
        </Flex>
        <NotMobile>
          <Flex pl={Space.S40} pt="80px" width={2 / 5} alignItems="center">
            <Illustration width="433px" height="400px" viewBox="0 0 433 400" />
          </Flex>
        </NotMobile>
      </Flex>
    </ContentWrapper>
  </AppWrapper>
)

export default PublicLayout
